import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlQueryParamsStateService {
  private _urlQueryParamsState = signal<Record<string, string | null>>({});
  public urlQueryParamsState = this._urlQueryParamsState.asReadonly();

  public setUrlQueryParamsState(params: Record<string, string | null>): void {
    this._urlQueryParamsState.set(params);
  }

  public hasUrlQueryParamsState(): boolean {
    return Object.values(this.urlQueryParamsState()).some(value => value !== null && value !== '');
  }

  public resetUrlQueryParamsState(): void {
    this._urlQueryParamsState.set({});
  }
}
